import { InputAdornment, TextField } from "@mui/material";
import { ReactElement, useState } from "react";

type Props = {
  prefix: string;
  placeholder?: string;
  width?: string;
  maxLength?: number;

  onChange(value: string): void;
};

export default function AssetPrefixSelector(props: Props): ReactElement {
  const { prefix, placeholder, width, maxLength, onChange } = props;

  const [value, setValue] = useState<string>("");

  return (
    <TextField
      onChange={(e) => {
        const string = maxLength
          ? e.target.value.slice(0, maxLength)
          : e.target.value;

        onChange(string);
        setValue(string);
      }}
      value={value}
      defaultValue={value}
      variant="outlined"
      id="filled-start-adornment"
      size="small"
      placeholder={placeholder}
      sx={{
        width: `${width ?? "150"}px`,
        ".MuiInputBase-root": {
          borderRadius: "15px",
        },
        ".MuiInputBase-input, .MuiInputLabel-root, .MuiTypography-root": {
          fontSize: "12px",
        },
      }}
      InputProps={
        (prefix && {
          startAdornment: (
            <InputAdornment position="start">{prefix}</InputAdornment>
          ),
        }) ||
        undefined
      }
    />
  );
}
